import { OfferListView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useOfferList } from '@/hooks/offers/useOfferList'
import { OFFERS_NAMESPACE } from '@/i18n'

/** `/offers` — the offer list and the New-offer entry (TO-466 REQ-005). */
export function OffersListPage() {
	const { t } = useTranslation(OFFERS_NAMESPACE)
	return <OfferListView t={t} {...useOfferList()} />
}
